import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { CopyVariantT } from './copy.types'

const containerConfig: Record<CopyVariantT, FlattenSimpleInterpolation> = {
  filled: css`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #eaeaea;
    justify-content: center;
    align-items: center;
  `,
  transparent: css``,
}

export const FilledCopyContainer = styled.div<{ variant?: CopyVariantT }>`
  display: flex;
  cursor: pointer;
  flex-shrink: 0;

  line-height: normal;

  ${({ variant = 'filled' }) => containerConfig[variant]};
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
